import { styled } from '@mui/system';
import { Box } from '@mui/material';
import { colors } from '../../constants/theme';
import { SOCIAL_LINKS } from '../../constants/socialLinks';

// Floating vertical social widget pinned to the right edge, vertically centered.
// Desktop only — on smaller screens the footer social row is used instead so the
// widget never crowds the mobile layout.
const SidebarContainer = styled(Box)(({ theme }) => ({
  display: 'none',
  // Visible on tablet and up; hidden below 700px where the mobile menu carries
  // the social links instead.
  [theme.breakpoints.up(700)]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    position: 'fixed',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1000,
    padding: '10px 8px',
    backgroundColor: colors.whiteText,
    borderRadius: '16px 0 0 16px',
    boxShadow: '-4px 0 24px rgba(41, 64, 90, 0.12)',
  },
}));

const IconLink = styled('a')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '34px',
  height: '34px',
  color: colors.secondary,
  transition: 'opacity 0.2s ease, transform 0.2s ease',
  '&:hover': {
    opacity: 0.6,
    transform: 'scale(1.1)',
  },
  '& svg': {
    fontSize: '20px',
  },
});

const SocialSidebar = () => {
  return (
    <SidebarContainer aria-label="Nirva social media">
      {SOCIAL_LINKS.map(({ name, url, Icon }) => (
        <IconLink
          key={name}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={name}
        >
          <Icon />
        </IconLink>
      ))}
    </SidebarContainer>
  );
};

export default SocialSidebar;
